import UltMeta, { Meta } from "./UltMeta/index";

//用户预付款记录
class GoodsName extends UltMeta {
    // 砂石
    SAND_STONE = new Meta("砂石", "砂石");
    // 煤炭
    COAL = new Meta("煤炭", "煤炭");
    // 黄金
    GOLD = new Meta("黄金", "黄金");
    // 欧冶废钢
    OUYE_SCRAP_STEEL = new Meta("欧冶废钢", "欧冶废钢");
    // 鸿泰废钢
    HONGTAI_SCRAP_STEEL = new Meta("鸿泰废钢", "鸿泰废钢");
    // 智利矿
    CHILE_MINERAL = new Meta("智利矿", "智利矿");
    // 烟煤
    BITUMINOUS_COAL = new Meta("烟煤", "烟煤");
    // 粤北废钢
    YUEBEI_SCRAP_STEEL = new Meta("粤北废钢", "粤北废钢");
    // 泰业废钢
    TAIYE_SCRAP_STEEL = new Meta("泰业废钢", "泰业废钢");
    // 钢厂废钢
    STEEL_PLANT_SCRAP_STEEL = new Meta("钢厂废钢", "钢厂废钢");
    // 大冶华鑫废钢
    DAYEHUA_XIN_SCRAP_STEEL = new Meta("大冶华鑫废钢", "大冶华鑫废钢");
    // PC钢棒用热轧盘
    PC_STEEL_ROD_HOT_ROLLED_COIL = new Meta("PC钢棒用热轧盘", "PC钢棒用热轧盘");
    // 预应力PC钢棒
    PRESTRESSED_PC_STEEL_ROD = new Meta("预应力PC钢棒", "预应力PC钢棒");
    // 金安废钢
    JINAN_SCRAP_STEEL = new Meta("金安废钢", "金安废钢");
    // 冷轧卷板
    COLD_ROLLED_COIL = new Meta("冷轧卷板", "冷轧卷板");
    // 汇泽废钢
    HUIZE_SCRAP_STEEL = new Meta("汇泽废钢", "汇泽废钢");
    // 旋力废钢
    XUANLI_SCRAP_STEEL = new Meta("旋力废钢", "旋力废钢");
    // 河源废钢
    HEYUAN_SCRAP_STEEL = new Meta("河源废钢", "河源废钢");
    // 热卷板（普)
    HOT_ROLLED_COIL_GENERAL = new Meta("热卷板（普)", "热卷板（普)");
    // 再生浆
    REGENERATED_PULP = new Meta("再生浆", "再生浆");
    // 酸洗卷板
    PICKLING_COIL = new Meta("酸洗卷板", "酸洗卷板");
    // 冷轧硬卷
    COLD_ROLLED_HARD_COIL = new Meta("冷轧硬卷", "冷轧硬卷");
    // 碳结板
    CARBON_STRUCTURAL_PLATE = new Meta("碳结板", "碳结板");
    // 冷镦钢
    COLD_HEADING_STEEL = new Meta("冷镦钢", "冷镦钢");
    // 花纹板卷
    CHECKERED_PLATE_COIL = new Meta("花纹板卷", "花纹板卷");
    // 低合金板卷
    LOW_ALLOY_PLATE_COIL = new Meta("低合金板卷", "低合金板卷");
    // 热轧板卷
    HOT_ROLLED_PLATE_COIL = new Meta("热轧板卷", "热轧板卷");
    // 钢绞线
    STEEL_STRAND = new Meta("钢绞线", "钢绞线");
    // 无缝钢管
    SEAMLESS_STEEL_PIPE = new Meta("无缝钢管", "无缝钢管");
    // 粉煤灰
    FLY_ASH = new Meta("粉煤灰", "粉煤灰");
    // 国内矿
    DOMESTIC_MINERAL = new Meta("国内矿", "国内矿");
    // 南非矿
    SOUTH_AFRICAN_MINERAL = new Meta("南非矿", "南非矿");
    // 金晟兰废钢
    JINSHENGLAN_SCRAP_STEEL = new Meta("金晟兰废钢", "金晟兰废钢");
    // 澳矿
    AUSTRALIAN_MINERAL = new Meta("澳矿", "澳矿");
    // 原纸
    RAW_PAPER = new Meta("原纸", "原纸");
    // 竹浆
    BAMBOO_PULP = new Meta("竹浆", "竹浆");
    // 热轧板卷（重复，可根据实际情况修改）
    HOT_ROLLED_PLATE_COIL_2 = new Meta("热轧板卷", "热轧板卷");
    // 镀锌卷
    GALVANIZED_COIL = new Meta("镀锌卷", "镀锌卷");
    // 金盛兰废钢
    JINSHENGLAN_SCRAP_STEEL_2 = new Meta("金盛兰废钢", "金盛兰废钢");
    // 钢管
    STEEL_PIPE = new Meta("钢管", "钢管");
    // 财源五金废钢
    CAIYUANWUJIN_SCRAP_STEEL = new Meta("财源五金废钢", "财源五金废钢");
    // 冷成型用冷轧低碳钢带
    COLD_FORMED_LOW_CARBON_COLD_ROLLED_STRIP = new Meta("冷成型用冷轧低碳钢带", "冷成型用冷轧低碳钢带");
    // 焦粒
    COKE_PELLETS = new Meta("焦粒", "焦粒");
    // 巴西矿
    BRAZILIAN_MINERAL = new Meta("巴西矿", "巴西矿");
    // 混合矿
    MIXED_MINERAL = new Meta("混合矿", "混合矿");
    // 冶金焦
    METALLURGICAL_COKE = new Meta("冶金焦", "冶金焦");
    // 工字钢
    I_BEAM = new Meta("工字钢", "工字钢");
    // 尚倾椒（可根据实际情况修改）
    SHANGQINGJIAO = new Meta("尚倾椒", "尚倾椒");
    // 砖瓦
    BRICKS_AND_TILES = new Meta("砖瓦", "砖瓦");
    // 优焊线
    HIGH_QUALITY_WELDING_WIRE = new Meta("优焊线", "优焊线");
    // 冷轧
    COLD_ROLLING = new Meta("冷轧", "冷轧");
    // 焜烨废钢
    KUNYE_SCRAP_STEEL = new Meta("焜烨废钢", "焜烨废钢");
    // 混凝土
    CONCRETE = new Meta("混凝土", "混凝土");
    // 冷轧板卷（重复，可根据实际情况修改）
    COLD_ROLLED_COIL_2 = new Meta("冷轧板卷", "冷轧板卷");
    // 胶合板
    PLYWOOD = new Meta("胶合板", "胶合板");
    // 石膏板
    GYPSUM_BOARD = new Meta("石膏板", "石膏板");
    // 锌铝镁板卷
    ZINC_ALUMINUM_MAGNESIUM_PLATE_COIL = new Meta("锌铝镁板卷", "锌铝镁板卷");
    // 铝塑板
    ALUMINUM_PLASTIC_BOARD = new Meta("铝塑板", "铝塑板");
    // 水泥
    CEMENT = new Meta("水泥", "水泥");
    // 低合金高强板
    LOW_ALLOY_HIGH_STRENGTH_PLATE = new Meta("低合金高强板", "低合金高强板");
    // 高强板
    HIGH_STRENGTH_PLATE = new Meta("高强板", "高强板");
    // 混凝土（重复，可根据实际情况修改）
    CONCRETE_2 = new Meta("混凝土", "混凝土");
    // 冷轧板卷（重复，可根据实际情况修改）
    COLD_ROLLED_COIL_3 = new Meta("冷轧板卷", "冷轧板卷");
    // 镀锌卷（重复，可根据实际情况修改）
    GALVANIZED_COIL_2 = new Meta("镀锌卷", "镀锌卷");
    // 耐磨板
    WEAR_RESISTANT_PLATE = new Meta("耐磨板", "耐磨板");
    // 普板
    COMMON_PLATE = new Meta("普板", "普板");
    // 新锰（可根据实际情况修改）
    NEW_MANGANESE = new Meta("新锰", "新锰");
    // 冷成形卷
    COLD_FORMED_COIL = new Meta("冷成形卷", "冷成形卷");
    // 酸洗卷板（重复，可根据实际情况修改）
    PICKLING_COIL_2 = new Meta("酸洗卷板", "酸洗卷板");
    // 螺纹钢
    REBAR = new Meta("螺纹钢", "螺纹钢");
    // 盘螺
    COILED_REBAR = new Meta("盘螺", "盘螺");
    // 高线
    HIGH_SPEED_WIRE_ROD = new Meta("高线", "高线");
}

export const GOODS_NAME = new GoodsName();
